import { UserManager, WebStorageStateStore } from 'oidc-client-ts'

// NOTE: Customer auth via Entra External ID is a placeholder.
// MVP 4 will replace this with an OTP-based Worker flow (no password required for customers).
const authority = import.meta.env.VITE_ENTRA_AUTHORITY as string
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID as string
// apiScope targets our own API app registration, not the Microsoft Graph.
// Without it Entra would issue a Graph-scoped token that our Worker would reject.
const apiScope = import.meta.env.VITE_ENTRA_API_SCOPE as string

const redirectUri = `${window.location.origin}/callback`
const postLogoutRedirectUri = `${window.location.origin}/`

if (!authority || !clientId || !apiScope) {
  throw new Error('VITE_ENTRA_AUTHORITY, VITE_ENTRA_CLIENT_ID, and VITE_ENTRA_API_SCOPE must be set')
}

export const userManager = new UserManager({
  authority,
  client_id: clientId,
  redirect_uri: redirectUri,
  post_logout_redirect_uri: postLogoutRedirectUri,
  // `offline_access` requests a refresh token so oidc-client-ts can silently
  // renew the access token when it expires (see automaticSilentRenew below).
  // `apiScope` ensures the access token audience matches our Worker, not the Graph API.
  scope: `openid profile email offline_access ${apiScope}`,
  response_type: 'code', // PKCE authorization-code flow
  // userStore holds only the OIDC session state (code verifier, nonce, etc.)
  // in sessionStorage. The access token itself lives only in React state via
  // AuthProvider, which limits XSS exposure.
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  // When the access token is close to expiry, oidc-client-ts opens a hidden
  // iframe to silently re-authenticate using the refresh token.
  automaticSilentRenew: true,
  silent_redirect_uri: `${window.location.origin}/silent-renew`,
})
